module.exports = __webpack_public_path__ + "img/pic_sell_price@2x.8e2efa34.png";